import { Trans, useTranslation } from 'react-i18next';

interface PerformanceModuleHeaderProps {
  header: string;
  territory: string;
  startDate: string;
  endDate: string;
}

export function PerformanceModuleHeader({
  header,
  territory,
  startDate,
  endDate,
}: PerformanceModuleHeaderProps) {
  const { t } = useTranslation('roster');

  return (
    <div className="flex flex-col">
      <h2 className="mb-xs text-headline-md font-semibold">{header}</h2>
      <div className="mb-lg text-caption-md text-subtle">
        <Trans
          t={t}
          i18nKey="trackDetails.releaseDate"
          values={{
            dateStart: startDate,
            dateEnd: endDate,
          }}
          components={{
            strong: <span className="font-semibold" />,
          }}
        />
        <span className="inline-flex text-caption-md text-emphasis-strong">
          <div className="mx-sm size-sm rounded-full bg-emphasis-strong" />
        </span>
        <span className="font-semibold">{territory}</span>
      </div>
    </div>
  );
}

PerformanceModuleHeader.displayName = 'PerformanceModuleHeader';
